module.exports = __webpack_public_path__ + "static/media/2.8e2374c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/grodno/2.jpg
// module id = 224
// module chunks = 0